import { Injectable, signal } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthenticationService } from './authentication.service';
import { v4 as uuidv4 } from 'uuid';
import { UriApi } from '../helpers/UriApi';
import { retry } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class ReservationService {
  body = {
    request: {
      jsonParams: {},
      functionCode: 109,
      data: "",
      dataList: "",
      menuCd: '',
    }
  };
  constructor(private http: HttpClient, private auth: AuthenticationService
  ) { }
  KEY_NAME = 'RESERVATION_POS_IDEMPOTENCY';

  getOrCreateIdempotencyKey(): string {
    let key = localStorage.getItem(this.KEY_NAME);

    if (!key) {
      key = uuidv4();
      localStorage.setItem(this.KEY_NAME, key);
    }

    return key;
  }
  resetIdempotencyKey() {
    localStorage.removeItem(this.KEY_NAME);
  }
  addReservation(param: any = {}) {
    this.body.request.jsonParams = param;
    const headers = new HttpHeaders({
      'Idempotency-Key': this.getOrCreateIdempotencyKey()
    });

    return this.http.post(
      UriApi.api_reservation_post,
      this.body,
      { headers }
    ).pipe(retry(3));
  }

  updateStatus(param: any) {
    this.body.request.jsonParams = param;
    return this.http.post(UriApi.api_reservation_updateStatus, this.body)
  }
}
